import {
  Component,
  effect,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  signal,
  WritableSignal,
} from '@angular/core';
import {
  LOGIN_TYPE,
  WavesConnectorService,
} from '@services/waves-connector.service';
import {
  ILoginType,
  SelectLoginTypeModalComponent,
} from '../select-login-type-modal/select-login-type-modal.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-login-to-waves',
  standalone: true,
  imports: [CommonModule, SelectLoginTypeModalComponent],
  templateUrl: './login-to-waves.component.html',
  styleUrl: './login-to-waves.component.scss',
})
export class LoginToWavesComponent {
  constructor(private _wavesConnectorService: WavesConnectorService) {
    effect(
      () => {
        if (this.triggerLogin()) {
          this.showSelectingLoginTypeModal();
        }
      },
      { allowSignalWrites: true },
    );
  }

  private _loginTypeSelected: WritableSignal<LOGIN_TYPE | null> =
    signal<LOGIN_TYPE | null>(null);

  private async _login(loginType: LOGIN_TYPE) {
    await this._wavesConnectorService.login(loginType);
    this.selectingLoginType.set(false);
    this.confirmLogin.emit();
  }

  protected loginTypes: ILoginType[] = [
    {
      value: LOGIN_TYPE.SIGNER_EMAIL,
      name: 'WX.Network Email',
      icon: 'assets/icons/login-types/email.svg',
    },
    {
      value: LOGIN_TYPE.SIGNER_SEED,
      name: 'Seed phrase',
      icon: 'assets/icons/login-types/seed.svg',
    },
    {
      value: LOGIN_TYPE.KEEPER_MOBILE,
      name: 'Keeper Mobile',
      icon: 'assets/icons/login-types/keeper.svg',
    },
    {
      value: LOGIN_TYPE.KEEPER,
      name: 'Keeper Wallet',
      icon: 'assets/icons/login-types/keeper.svg',
    },
    {
      value: LOGIN_TYPE.LEDGER,
      name: 'Ledger',
      icon: 'assets/icons/login-types/ledger.svg',
    },
  ];

  protected setLoginType(loginType: LOGIN_TYPE) {
    this._loginTypeSelected.set(loginType);
  }

  protected hideSelectingLoginTypeModal() {
    this.selectingLoginType.set(false);
  }

  protected selectingLoginType: WritableSignal<boolean> = signal(false);

  protected showSelectingLoginTypeModal() {
    this.selectingLoginType.set(true);
  }

  public triggerLogin: InputSignal<boolean> = input(false);

  public disableControls: InputSignal<boolean> = input(false);

  public confirmLogin: OutputEmitterRef<void> = output();
}
